import { Link } from "react-router";
import { EmptyState, Icon } from "@xinghai/ui";

export function NotFoundPage() {
  return (
    <div className="xz-container">
      <EmptyState
        icon={<Icon id="ui-search" size={24} />}
        title="没找到这个页面"
        description="链接可能输错了，或者内容已经下线。"
        action={
          <Link className="gz-button gz-button--primary" to="/">
            回到首页
          </Link>
        }
      />
    </div>
  );
}
